import { PayinAppeal, PayinCreateOrder, PayinOrderChecks } from '~/features/payin';
import { PayoutDeclineOrder, PayoutSplitOrder } from '~/features/payout';
import { MODALS } from '~/shared/constants/modals';
import { type ResponsiveModalsMap } from '~/shared/ui/ResponsiveModals';
import { withResponsiveModalProps } from './hoc/withResponsiveModalProps';

export const responsiveModalsMap = {
    [MODALS.PAYIN_ORDER_CREATION]: withResponsiveModalProps(PayinCreateOrder),
    [MODALS.PAYIN_ORDER_APPEAL]: withResponsiveModalProps(PayinAppeal),
    [MODALS.PAYIN_ORDER_CHECKS]: withResponsiveModalProps(PayinOrderChecks),
    [MODALS.PAYOUT_ORDER_REJECTION]: withResponsiveModalProps(PayoutDeclineOrder),
    [MODALS.PAYOUT_ORDER_SPLIT]: withResponsiveModalProps(PayoutSplitOrder),
} satisfies ResponsiveModalsMap;
